export const USER_ROLES = {
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_USER: "ROLE_USER",
  ROLE_PREMIUM_USER: "ROLE_PREMIUM_USER",
  ROLE_WRITER: "ROLE_WRITER",
  ROLE_STUDENT: "ROLE_STUDENT",
  ROLE_TEACHER: "ROLE_TEACHER",
};

export const PROGRAMMING_LANGUAGES = {
  PYTHON: "Python",
  JAVASCRIPT: "Javascript",
  JAVA: "Java",
  C: "C",
  CPP: "C++",
};

export const VISIBILITY = {
  PUBLIC: "Public",
  PRIVATE: "Private",
};

export const COURSE_FOR = {
  BEGINNERS: "Beginners",
  INTERMEDIATE: "Intermediate",
  ADVANCED: "Advanced",
};

export const DURATION = {
  DAYS: "Days",
  WEEKS: "Weeks",
  MONTHS: "Months",
};

export const CONTENT_TYPE = {
  YOUTUBE: "YouTube",
  VIMEO: "Vimeo",
};

export const THUMBNAIL_CONTENT_TYPE = {
  "image/jpeg": "image/jpeg",
  "image/png": "image/png",
  "image/jpg": "image/jpg",
  "image/gif": "image/gif",
  "video/mp4": "video/mp4",
};

export const LOCAL_STORAGE_KEY = "BulkUpdateJsonInput";

export const SUBMISSION_STATUSES = {
  PROCESSING: "PROCESSING",
  IN_QUEUE: "IN_QUEUE",
  ACCEPTED: "ACCEPTED",
  RUNTIME_ERROR: "RUNTIME_ERROR",
  COMPILATION_ERROR: "COMPILATION_ERROR",
  SUCCESS: "SUCCESS",
  TIME_LIMIT_EXCEEDED: "TIME_LIMIT_EXCEEDED",
  INVALID_ANSWER: "INVALID_ANSWER",
  colorMap: {
    PROCESSING: "warning",
    IN_QUEUE: "info",
    ACCEPTED: "success",
    RUNTIME_ERROR: "error",
    COMPILATION_ERROR: "error",
    SUCCESS: "success",
    TIME_LIMIT_EXCEEDED: "warning",
    INVALID_ANSWER: "error",
  },
};

export const LOADING_MESSAGES = [
  "Compiling...",
  "Executing your code...",
  "Fetching results...",
];

export const ALERT_SEVERITIES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const HEIGHT_OFFSET = {
  DEFAULT: "240px",
  PROGRAMMING_CONTENT: "185px",
};

export const OPERATOR_LABELS = {
  equals: "Equals",
  contains: "Contains",
  in: "In",
  specified: "Specified",
  greater_than: "Greater Than",
  less_than: "Less Than",
  greater_than_or_equal: "Greater Than Or Equal",
  less_than_or_equal: "Less Than Or Equal",
};

export const FIELD_TYPES = {
  NUMBER: "number",
  STRING: "string",
  BOOLEAN: "boolean",
  DATE: "date",
  ARRAY: "array",
  OBJECT: "object",
  IMAGE: "image",
  ENUM: "enum",
  PASSWORD: "password",
  TEXTAREA: "textarea",
  HTML: "html",
  SELECT: "select",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  TEXT: "text",
  FILE: "file",
  NESTED_ARRAY: "nested_array",
  FOREIGN_KEY: "foreign_key",
};

export const REQUEST_TYPES = {
  REQUEST_ACCESS: "Request Access",
  COURSE_NOT_FOUND: "Course Not Found",
  WRITING_REQUEST: "Writing Request",
  BUG: "Bug",
  INSTITUTE_NOT_FOUND: "Institute Not Found",
  FEATURE_REQUEST: "Feature Request",
  OTHERS: "Others",
  colorMap: {
    REQUEST_ACCESS: "warning",
    COURSE_NOT_FOUND: "warning",
    WRITING_REQUEST: "info",
    BUG: "error",
    INSTITUTE_NOT_FOUND: "secondary",
    FEATURE_REQUEST: "primary",
    OTHERS: "default",
  },
};

export const PAYMENT_STATUS = {
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  PAYMENT_COMPLETED: "PAYMENT_COMPLETED",
  REFUND_UNDER_PROCESS: "REFUND_UNDER_PROCESS",
  REFUND_COMPLETED: "REFUND_COMPLETED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  colorMap: {
    PAYMENT_INITIATED: "secondary",
    PAYMENT_COMPLETED: "primary",
    REFUND_UNDER_PROCESS: "info",
    REFUND_COMPLETED: "success",
    PAYMENT_FAILED: "error",
  },
};

export const REQUEST_STATUS = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  colorMap: {
    PENDING: "error",
    RESOLVED: "success",
  },
};

export const STATUS = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  RETURNED: "RETURNED",
  colorMap: {
    ACTIVE: "primary",
    EXPIRED: "error",
    RETURNED: "warning",
  },
};

export const SOCIAL_PLATFORMS = {
  YOUTUBE: "YouTube",
  X: "X",
  LINKEDIN: "LinkedIn",
  INSTAGRAM: "Instagram",
  colorMap: {
    YOUTUBE: "error",
    X: "primary",
    LINKEDIN: "info",
    INSTAGRAM: "secondary",
  },
};
